export const PERSON_LABELS = {
    ik: 'ik',
    jij: 'jij/je',
    hij: 'hij/zij/het',
    wij: 'wij/we',
    jullie: 'jullie',
    zij: 'zij/ze (plural)',
};
export const TENSE_LABELS = {
    pastSingular: 'Verleden tijd (enkelvoud)',
    pastPlural: 'Verleden tijd (meervoud)',
    pastParticiple: 'Voltooid deelwoord',
};
//# sourceMappingURL=verbs.js.map